import React from 'react';

const NicknameModal = ({ nicknames, onSelect }) => {
  // Determine grid columns based on number of nicknames
  const getGridCols = (count) => {
    if (count <= 8) return 'grid-cols-2';
    if (count <= 15) return 'grid-cols-3';
    if (count <= 24) return 'grid-cols-4';
    return 'grid-cols-5';
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="bg-white p-6 shadow-2xl max-w-4xl w-full mx-4 border border-gray-300">
        <h2 className="text-xl font-semibold mb-5 text-gray-900 text-center">Select Your Nickname</h2>
        <div className={`grid ${getGridCols(nicknames.length)} gap-3`}>
          {nicknames.map((nicknameObj, index) => (
            <button
              key={index}
              onClick={() => onSelect(nicknameObj.NICKNAME)}
              className="bg-slate-700 hover:bg-slate-800 text-white py-4 px-6 text-base font-medium transition-colors w-full text-center"
            >
              {nicknameObj.NICKNAME}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NicknameModal;
